module.exports = __webpack_public_path__ + "img/emsbanner1-arrow.3638bf63.png";